import { render, staticRenderFns } from "./ForgotPasswordSuccess.vue?vue&type=template&id=7d824196&scoped=true&"
import script from "./ForgotPasswordSuccess.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d824196",
  null
  
)

export default component.exports